// ================== SALES PROPOSAL REDUX REDUCER ================== //

const initialState = {
  salesProposalData: { attachments: [] },
  currentViewTab: "New",
  refreshComments: true
};

export const SalesProposalReducer = (state = initialState, action) => {
  switch (action.type) {

    case "SET_SALESPROPOSAL":
      return { ...state, salesProposalData: action.payload };

    case "SET_SALESPROPOSAL_VIEW_TAB":
      return { ...state, currentViewTab: action.payload };

    case "SET_REFRESH_SALESPROPOSAL_COMMENTS":
      return { ...state, refreshComments: action.payload };

    case "RESET_SALESPROPOSAL_STATE":
      return initialState;

    default:
      return state;
  }
};


// ================== ACTION CREATORS ================== //

export const setSalesProposal = (data) => ({
  type: "SET_SALESPROPOSAL",
  payload: data
});

export const setSalesProposalViewTab = (tab) => ({
  type: "SET_SALESPROPOSAL_VIEW_TAB",
  payload: tab
});

export const setRefreshSalesProposalComments = (value) => ({
  type: "SET_REFRESH_SALESPROPOSAL_COMMENTS",
  payload: value
});

export const resetSalesProposalState = () => ({
  type: "RESET_SALESPROPOSAL_STATE"
});
